// hooks/useEvaluation.js - Custom hooks for evaluation data
import { useApi } from './useApi';
import { evaluationService } from '../services/evaluationService';

// Hook to get evaluation settings
export function useEvaluationSettings(boxId) {
  return useApi(
    async () => {
      if (!boxId) return null;
      return await evaluationService.getEvaluationSettings(boxId);
    },
    [boxId]
  );
}

// Hook to get evaluation results
export function useEvaluationResults(boxId, params = {}) {
  return useApi(
    async () => {
      if (!boxId) return null;
      return await evaluationService.getEvaluationResults(boxId, params);
    },
    [boxId, JSON.stringify(params)]
  );
}

// Hook to get latest evaluation result
export function useLatestEvaluationResult(boxId) {
  return useApi(
    async () => {
      if (!boxId) return null;
      return await evaluationService.getLatestEvaluationResult(boxId);
    },
    [boxId]
  );
}

// Hook to list anomaly detectors
export function useAnomalyDetectors(boxId) {
  return useApi(
    async () => {
      if (!boxId) return null;
      return await evaluationService.listAnomalyDetectors(boxId);
    },
    [boxId]
  );
}

// Hook to get anomaly detector metadata
export function useAnomalyDetectorMetadata(boxId, version) {
  return useApi(
    async () => {
      if (!boxId || !version) return null;
      return await evaluationService.getAnomalyDetectorMetadata(boxId, version);
    },
    [boxId, version]
  );
}